import axiosInstance from "../utils/axiosInstance";
import { URLS } from "../utils/baseUrls";

const fetchTeamMembers = (leId, teamId) => {
  return axiosInstance.get(`${URLS.legalEntities}/${leId}/teams/${teamId}/members/`);
};

const fetchTeamGroups = (leId, teamId) => {
  return axiosInstance.get(`${URLS.legalEntities}/${leId}/teams/${teamId}/groups/`);
};

const removeTeamMember = (leId, teamId, userId) => {
  return axiosInstance.delete(`${URLS.legalEntities}/${leId}/teams/${teamId}/members/${userId}/`);
};

const createTeam = (leId, data) => {
  return axiosInstance.post(`${URLS.legalEntities}/${leId}/teams/`, data);
};

const updateTeam = (leId, teamId, data) => {
  return axiosInstance.patch(`${URLS.legalEntities}/${leId}/teams/${teamId}/`, data);
};

const deleteTeam = (leId, teamId) => {
  return axiosInstance.delete(`${URLS.legalEntities}/${leId}/teams/${teamId}/`);
};

const assignTeamAdmin = (leId, teamId, userId) => {
  return axiosInstance.post(`${URLS.legalEntities}/${leId}/teams/${teamId}/assign-admin/`, {
    user_id: userId,
  });
};

const fetchTeamInvitations = (leId, teamId) => {
  return axiosInstance.get(`${URLS.legalEntities}/${leId}/teams/${teamId}/invitations/`);
};

const sendTeamInvitation = (leId, teamId, { invitedUserId, message }) => {
  return axiosInstance.post(`${URLS.legalEntities}/${leId}/teams/${teamId}/invitations/`, {
    invited_user_id: invitedUserId,
    message,
  });
};

const revokeTeamInvitation = (leId, teamId, invitationId) => {
  return axiosInstance.delete(
    `${URLS.legalEntities}/${leId}/teams/${teamId}/invitations/${invitationId}/revoke/`
  );
};

const fetchMyTeamInvitations = () => {
  return axiosInstance.get(`${URLS.teams}/invitations/my/`);
};

const respondToTeamInvitation = (token, action) => {
  return axiosInstance.post(`${URLS.teams}/invitations/${token}/${action}/`);
};

export const teamsApi = {
  fetchMembers: fetchTeamMembers,
  fetchGroups: fetchTeamGroups,
  removeMember: removeTeamMember,
  create: createTeam,
  update: updateTeam,
  deleteOne: deleteTeam,
  assignAdmin: assignTeamAdmin,
  fetchInvitations: fetchTeamInvitations,
  sendInvitation: sendTeamInvitation,
  revokeInvitation: revokeTeamInvitation,
  fetchMyInvitations: fetchMyTeamInvitations,
  respondToInvitation: respondToTeamInvitation,
};
